import Table from "PFComponents/table";

import { useFeedbackFormContext } from "../../feedback_form_context";
import { useSkillsTableColumns } from "./use_skills_table_columns";

type SkillsTableProps = {
  readOnly?: boolean;
};

export const SkillsTable = ({ readOnly }: SkillsTableProps) => {
  const { formData } = useFeedbackFormContext();

  const generateColumns = useSkillsTableColumns({ readOnly });

  return <Table tableData={formData?.skills || []} generateColumns={generateColumns} compact />;
};
